exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.event-name {\n  color: #0080A5;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.event-status {\n  font-weight: bold;\n  text-transform: capitalize;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24432e6d","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/MoveEvent.vue
// module id = 1432
// module chunks = 1